<template>
    <el-container style="overflow: hidden">
        <el-main>
            <el-row :gutter="20" class="paddingTop10">
                <el-col :span="5" :offset="3" style="text-align:right">{{ $t('pgCommon.MAIN_BOARD_SEQCENSE_NUMBER') }}</el-col>
                <el-col :span="10" style="text-align:left; width:360px"><label v-text="pollCode"></label></el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="5" :offset="3" style="text-align:right;margin-top:8px;">{{ $t('pgCommon.HASP_HL') }}</el-col>
                <el-col :span="6" style="text-align:left;margin-top:8px; width:360px">
                    <label v-text="haspHl"></label>
                </el-col>
                <el-col :span="4">
                    <td-button :loading="refLoading" @click="btnRefresh">{{ $t('pgCommon.REFRESH') }}</td-button>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="5" :offset="3" style="text-align:right;">{{ $t('common.AUTHORIZATION_TYPE') }}</el-col>
                <el-col :span="6" style="text-align:left;width:360px">
                    <td-radio v-model="autType" :options="optionsType" @change="change"></td-radio>
                </el-col>
            </el-row>
            <div id="showRegisterFile" style="display: block;">
                <el-row :gutter="20">
                    <el-col :span="5" :offset="3" style="text-align:right;margin-top:8px;">{{ $t('common.REGISTER_FILE') }}</el-col>
                    <el-col :span="6" style="width:360px">
                        <el-tooltip :disabled="tipDisabled" placement="top-start" width="250" effect="light" :content="fileName">
                            <td-input clearable="true" ref="fileNameKey" v-model="fileName" readonly="true" :placeholder="'common.PLEASE_SELECT'" width="100px"></td-input>
                        </el-tooltip>
                    </el-col>
                    <el-col :span="5" style="text-align:left">
                        <td-upload
                            actionUrl="/licenseserver/licenseAuthorizeController/uploadRegisterFile"
                            :autoUpload="false"
                            :hasManual="true"
                            :ref="upload"
                            message="common.UPLOAD_AUTHORIZATION_DOCUMENT"
                            :multiple="false"
                            :showFileList="false"
                            accept=".lrf"
                            limitSize="5"
                            :on-change="handChange"
                            :on-success="handResponse"
                            :on-error="handResponse"
                            :beforeRemove="beforeRemove"
                        ></td-upload>
                    </el-col>
                </el-row>
            </div>
            <div id="showRegisterCode" style="display: none;">
                <el-row :gutter="20">
                    <el-col :span="4" :offset="4" style="text-align:right;margin-top:8px;">{{ $t('common.REGISTER_CODE') }}</el-col>
                    <el-col :span="6" style="width:360px">
                        <td-input v-model="registerCode" type="textarea" :autosize="{ minRows: 1, maxRows: 6 }" width="100px"></td-input>
                    </el-col>
                    <el-col :span="6">
                        <td-button type="primary" :loading="loading" @click="btnCodeRegister">{{ $t('common.REGISTER_CODE_REGISTER') }}</td-button>
                    </el-col>
                </el-row>
            </div>
            <el-row class="paddingTop10">
                <el-col>
                    <td-table
                        rowKey="rowKey"
                        :dataSource="tableData"
                        :columns="columns"
                        :hasTreeTable="hasTreeTable"
                        :hasIndex="hasIndex"
                        :hasMutiSelect="hasMutiSelect"
                        :hasPage="hasPage"
                        childrenName="children"
                        :hasLoading="hasLoading"
                    ></td-table>
                </el-col>
            </el-row>
        </el-main>
    </el-container>
</template>
<script>
import licenseApi from './assets/api.js';
export default {
    // 初始化渲染
    components: {},
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.getRegisterInfo();
        this.getAllLicenseInfo();
    },
    // 定义数据
    data() {
        return {
            tableData: [],
            hasTreeTable: true,
            hasIndex: false,
            hasMutiSelect: false,
            hasPage: false,
            hasLoading: false,
            loading: false,
            refLoading: false,
            tipDisabled: true,
            fileName: '', //license文件名
            pollCode: null, //注册码
            haspHl: null, //加密锁
            registerCode: '', //授权码
            autType: '0', //授权类型
            optionsType: [
                {
                    value: '0',
                    label: this.$t('common.REGISTER_FILE_REGISTER')
                },
                {
                    value: '1',
                    label: this.$t('common.REGISTER_CODE_REGISTER')
                }
            ],
            columns: [
                {
                    label: 'pgCommon.SYSTEM_NAME',
                    prop: 'name',
                    minWidth: '300',
                    render: (createElement, params) => {
                        let systemName = params.row.name;
                        if (params.row.dataType == 1) {
                            systemName = systemName + '【' + this.$t('pgCommon.LICENSE_ID') + params.row.id + '】';
                        }
                        return createElement('span', systemName);
                    }
                },
                {
                    label: 'pgCommon.LICENSE_TIME',
                    prop: 'createTime',
                    minWidth: '150',
                    align: 'center'
                },
                {
                    label: 'pgCommon.TERM_OF_VALIDITY',
                    prop: 'term',
                    minWidth: '150',
                    align: 'center'
                }
            ]
        };
    },
    watch: {
        fileName: {
            handler(newVal, oldVal) {
                if (this.$util.isEmpty(newVal)) {
                    this.tipDisabled = true;
                } else {
                    this.tipDisabled = false;
                }
            },
            immediate: true
        }
    },

    // 方法的实现
    methods: {
        btnRefresh() {
            this.refLoading = true;
            this.getRegisterInfo();
        },

        change(value) {
            if (value == 0) {
                document.getElementById('showRegisterFile').style.display = 'block'; //不显示
                document.getElementById('showRegisterCode').style.display = 'none'; //显示
            }
            if (value == 1) {
                document.getElementById('showRegisterFile').style.display = 'none'; //不显示
                document.getElementById('showRegisterCode').style.display = 'block'; //显示
            }
        },
        handChange(file) {
            this.fileName = file.name;
        },
        beforeRemove(file, fileList) {
            this.$refs.fileNameKey.currentValue = '';
            this.fileName = '';
        },
        handResponse(response) {
            this.$refs.fileNameKey.currentValue = '';
            this.fileName = '';
            if (response.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({
                    showClose: true,
                    message: response.statusMessage,
                    type: 'error'
                });
                this.$log.error('/licenseAuthorizeController/uploadRegisterFile', response.statusMessage);
                return;
            }
            this.$message({
                showClose: true,
                message: this.$t('pgMessage.LICENSE_FILE_UPLOAD_SUCCESS'),
                type: 'success'
            });
            setTimeout(this.getAllLicenseInfo, 6000);
        },
        //获取授权信息
        getRegisterInfo() {
            licenseApi.listRegisterInfo(null, response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({
                        showClose: true,
                        message: response.data.statusMessage,
                        type: 'error'
                    });
                    this.$log.error('licenseAuthorizeController/listRegisterInfo', response);
                    this.refLoading = false;
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({
                        showClose: true,
                        message: response.data.statusMessage,
                        type: 'error'
                    });
                    this.$log.error('licenseAuthorizeController/listRegisterInfo', response.data.statusMessage);
                    this.refLoading = false;
                    return;
                }
                if (this.$util.isEmpty(response.data.content)) {
                    this.$log.error('licenseAuthorizeController/listRegisterInfo', response.data.content);
                    this.refLoading = false;
                    return;
                }
                if (this.$util.isEmpty(response.data.content.pollCode)) {
                    this.pollCode = this.$t('pgMessage.POLL_CODE_NULL');
                } else {
                    this.pollCode = response.data.content.pollCode;
                }
                if (this.$util.isEmpty(response.data.content.haspHl)) {
                    this.haspHl = this.$t('pgMessage.HASP_HL_NULL');
                } else {
                    let haspHlInfo = response.data.content.haspHl;
                    let dogSN = haspHlInfo.substring(0, haspHlInfo.indexOf('-'));
                    let dogHid = haspHlInfo.substring(haspHlInfo.indexOf('-') + 1, haspHlInfo.indexOf('（'));
                    let dogEdition = haspHlInfo.substring(haspHlInfo.indexOf('（'));
                    this.haspHl = dogHid + '-' + dogSN + dogEdition;
                }
                this.refLoading = false;
            });
        },

        // 获取所有授权信息
        getAllLicenseInfo() {
            licenseApi.getAllLicenseInfo(null, response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({
                        showClose: true,
                        message: response.data.statusMessage,
                        type: 'error'
                    });
                    this.$log.error('licenseAuthorizeController/getAllLicenseInfo', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({
                        showClose: true,
                        message: response.data.statusMessage,
                        type: 'error'
                    });
                    this.$log.error('licenseAuthorizeController/getAllLicenseInfo', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
            });
        },

        //授权码认证
        btnCodeRegister() {
            if (this.$util.isEmpty(this.registerCode)) {
                this.$message({
                    showClose: true,
                    message: this.$t('error.ERROR_REGISTER_CODE_NULL'),
                    type: 'warning'
                });
                this.loading = false;
                return;
            }
            var param = {
                registerCode: this.registerCode
            };
            licenseApi.registerCodeEmpower(param, response => {
                this.registerCode = '';
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$message({
                        showClose: true,
                        message: response.data.statusMessage,
                        type: 'error'
                    });
                    this.loading = false;
                    this.$log.error('licenseAuthorizeController/registerCodeEmpower', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({
                        showClose: true,
                        message: response.data.statusMessage,
                        type: 'error'
                    });
                    this.$log.error('licenseAuthorizeController/registerCodeEmpower', response.data.statusMessage);
                    this.loading = false;
                    return;
                }
                this.loading = false;
                this.$message({
                    showClose: true,
                    message: this.$t('pgMessage.CREATE_LICENSE_FILE_UPLOAD_SUCCESS'),
                    type: 'success'
                });
                setTimeout(this.getAllLicenseInfo, 6000);
            });
        }
    }
};
</script>
<style scoped>
.el-main-class {
    margin-top: 20px;
}
.fieldsetStyle {
    border: 2px solid #eee;
    width: 98%;
}
</style>
